(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["location-info"]) return;
  try {
    

	$(function() {

		$('#mli-select').on('change', function() {
			var option = $('option:selected', this);
			var selection = option.val();

			$('.mli-content.active').removeClass('active');

			$('.mli-content[data-option="' + selection + '"]').addClass('active');
		});

	});


  } catch(e) { console.error(e); }
})();
})();
